import { Component, Input } from '@angular/core';
import { SiniestroComplemento, SiniestroDet } from 'src/app/models/complementos-web/complementos-web.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-detalle-siniestro-resumen',
    templateUrl: './detalle-siniestro-resumen.component.html',
    styleUrls: ['./detalle-siniestro-resumen.component.scss'],
    imports: [NgClass]
})
export class DetalleSiniestroResumenComponent {

  @Input() siniestro: SiniestroDet;
  @Input() siniestroSeleccionado: SiniestroComplemento;

  public screenSize: string = '';

  constructor(
    private procesosComplementoService: ProcesosComunesComplementoService,
  ) {
    this.tamanoPantalla();
  }

  tamanoPantalla() {
    const subScreen = this.procesosComplementoService.screenSize$.subscribe(size => {
      this.screenSize = size;
    });
  }
}
